import {
  Flex,
  FlexItem,
  Title,
  TextContent,
  TextList,
  TextListVariants,
  TextListItem,
  TextListItemVariants,
  Divider,
} from '@patternfly/react-core'
import * as React from 'react'

import { PatientBirthSex } from '@app/domain/patient/components/patient-birth-sex.component'
import type { IPatient } from '@app/domain/patient/patient.interface'
import PersonName from '@app/domain/person/components/person-name.component'
import type * as Patients from '@app/state/patients'
import { SmallButton } from '@app/utils/styles/small-button'

import { UpdatePatientStatus } from './patient-status'

interface Props {
  isSelectPatientAllowed?: boolean
  onSelectPatient?: () => void
  onSetEditable?: () => void
  patient: IPatient
  updateStatus?: Patients.PatientActionStatusId
}

export const ReadOnlyPatientCard = ({
  isSelectPatientAllowed,
  onSelectPatient,
  onSetEditable,
  patient,
  updateStatus,
}: Props) => {
  return (
    <Flex direction={{ default: 'column' }}>
      <FlexItem>
        <Flex direction={{ default: 'row' }}>
          <FlexItem>
            <Title headingLevel="h2" size="lg">
              Patient Information
            </Title>
          </FlexItem>
          <FlexItem>
            {onSetEditable ? (
              <SmallButton variant="secondary" onClick={onSetEditable}>
                Edit
              </SmallButton>
            ) : null}
          </FlexItem>
          <FlexItem>
            <UpdatePatientStatus updateStatus={updateStatus} />
          </FlexItem>
          {isSelectPatientAllowed ? (
            <>
              <Divider
                orientation={{
                  default: 'vertical',
                }}
              />
              <FlexItem>
                <SmallButton variant="secondary" onClick={onSelectPatient}>
                  Select Patient
                </SmallButton>
              </FlexItem>
            </>
          ) : null}
        </Flex>
      </FlexItem>
      <FlexItem>
        <TextContent>
          <TextList component={TextListVariants.dl}>
            <TextListItem component={TextListItemVariants.dt}>
              Name:
            </TextListItem>
            <TextListItem component={TextListItemVariants.dd}>
              <PersonName namedPerson={patient} />
            </TextListItem>
            <TextListItem component={TextListItemVariants.dt}>
              MRN:
            </TextListItem>
            <TextListItem component={TextListItemVariants.dd}>
              {patient.medicalRecordNumber}
            </TextListItem>
            <TextListItem component={TextListItemVariants.dt}>
              DOB:
            </TextListItem>
            <TextListItem component={TextListItemVariants.dd}>
              {patient.dateOfBirth}
            </TextListItem>
            <TextListItem component={TextListItemVariants.dt}>
              Birth Sex:
            </TextListItem>
            <TextListItem component={TextListItemVariants.dd}>
              <PatientBirthSex patient={patient} />
            </TextListItem>
            <TextListItem component={TextListItemVariants.dt}>
              Family Doctor:
            </TextListItem>
            <TextListItem component={TextListItemVariants.dd}>
              {patient.generalPractitioner}
            </TextListItem>
          </TextList>
        </TextContent>
      </FlexItem>
    </Flex>
  )
}
